export default {
  props:{
    media:{type:String,default:''},
    mediaSize:{type:String,default:'24px'},
  }
}
